import script from "./ModalDetalleEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDetalleEvento.vue?vue&type=script&setup=true&lang=js"

import "./ModalDetalleEvento.vue?vue&type=style&index=0&id=5d6c53a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6c53a4"]])

export default __exports__